/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Agent_IdInputs */

const cs_field_agent_id = /** @type {(inputs: Field_Agent_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID agenta`)
};

const en_field_agent_id = /** @type {(inputs: Field_Agent_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent ID`)
};

/**
* | output |
* | --- |
* | "Agent ID" |
*
* @param {Field_Agent_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_agent_id = /** @type {((inputs?: Field_Agent_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Agent_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_agent_id(inputs)
	return cs_field_agent_id(inputs)
});